export default "__VITE_ASSET__Dy3_Edkv__"